<script lang="ts">
import { Auth0Client } from '@auth0/auth0-spa-js';
import { user, authenticated } from './store.js';
import Authentication, {isAuthenticated, getCurrentUser, getCurrentToken} from "./Authentication.svelte";
import Tailwind from "./Tailwind.svelte";
import Header from "./Header.svelte";
import Login from "./Login.svelte";
import Server from "./Server.svelte";

isAuthenticated();
if (authenticated) {
    getCurrentUser();
    getCurrentToken();
}
</script>

{#await $authenticated}
{:then authentication_result}
{#if authentication_result}
<Tailwind />
<Header />
<Server />
{:else}
<Login />
{/if}
{/await}
